import { motion } from "motion/react";
import clsx from "clsx";
import { imgAvatar } from "@/shared/assets/img";
import { VolumeIcon } from "@/shared/icons";
import { Color } from "@/domains/dialogue/constants/color";

type Props = {
  subject: string;
  text: string;
  color?: Color;
  className?: string;
};

export default function DialogueNpcMessage({
  subject,
  text,
  color = Color.Default,
  className,
}: Props) {
  return (
    <motion.div
      initial={{ translateX: "-100%", opacity: 0 }}
      animate={{ translateX: "0", opacity: 1 }}
      transition={{
        bounce: false,
        duration: 0.2,
      }}
      exit={{
        translateX: "-100%",
        opacity: 0,
      }}
      className={clsx("w-fit w-max-[26.625rem] relative isolate rounded-[0.875rem]", className)}
    >
      <div
        className={clsx(
          "absolute inset-y-0 -right-0.5 w-[2rem] bg-dark-900 rounded-[inherit] pointer-events-none z-0",
          {
            "[background-image:linear-gradient(to_bottom,transparent,#FFB45C40_25%,#FFB45C_50%,#FFB45C40_75%,transparent)]":
              color === Color.Yellow,
            "[background-image:linear-gradient(to_bottom,transparent,#5FFF6940_25%,#5FFF69_50%,#5FFF6940_75%,transparent)]":
              color === Color.Green,
          },
        )}
      />
      <div className="absolute bg-dark-900 w-[0.5rem] h-[0.5rem] top-5 -left-[0.25rem] rotate-45" />
      <div className="absolute z-1 inset-0 bg-dark-900 rounded-[inherit]" />
      <div
        className={clsx(
          "absolute inset-y-0 left-0 -right-[0.15rem] rounded-[inherit] z-1 bg-gradient-to-r from-transparent",
          {
            "to-[#FFB45C]/20": color === Color.Yellow,
            "to-[#5FFF69]/20": color === Color.Green,
          },
        )}
      />

      <div className="relative z-2 flex flex-col p-5 gap-2.5 rounded-[inherit]">
        <div className="flex items-start gap-3">
          <div
            className={clsx(
              "w-[2.625rem] aspect-square shrink-0 flex items-center justify-center",
              "border-2  rounded-[0.5rem]",
              {
                "border-white/20": color === Color.Default,
                "border-[#FFB45C]": color === Color.Yellow,
                "border-[#5FFF69]": color === Color.Green,
              },
            )}
          >
            <img
              src={imgAvatar}
              alt=""
              className="w-[2.125rem] aspect-square shrink-0 rounded-[0.3rem]"
            />
          </div>
          <div className="flex flex-col gap-1 grow">
            <div className="flex items-center justify-between gap-2.5 text-15 font-bold">
              <div
                className={clsx({
                  "text-[#FFB45C]": color === Color.Yellow,
                  "text-[#5FFF69]": color === Color.Green,
                })}
              >
                Алиса Федорова
              </div>
              <VolumeIcon size={16} />
            </div>
            <div className="text-15 font-bold">{subject}:</div>
            {/* <div className="flex items-center justify-between gap-2.5 text-15 font-bold">
              <div>Оплата штрафов ГИБДД:</div>
              <VolumeIcon size={16} />
            </div>
            <div className="text-15 text-white/70 font-medium">
              Здравствуйте, хотите оплатить штраф ГИБДД?
            </div> */}
          </div>
        </div>
        <div className="text-15 font-medium text-white/70">{text}</div>
        {/* <div className="flex items-center justify-between">
          <img src="./svg/sbank.svg" alt="" className="h-[1.25rem]" />
          <div className="text-15 text-[#5FFF69] font-bold">Виталий Гогунский</div>
        </div> */}
      </div>
    </motion.div>
  );
}
